import React from "react";
import { Link as RouterLink, LinkProps as RouterLinkProps } from "react-router-dom";

export interface LinkProps extends Omit<RouterLinkProps, "to"> {
 to: string;
 variant?: "default" | "primary" | "muted" | "underline";
 external?: boolean;
}

const variantClasses = {
 default: "text-gray-900 hover:text-gray-700",
 primary: "text-blue-600 hover:text-blue-800",
 muted: "text-gray-600 hover:text-gray-800",
 underline: "text-blue-600 hover:text-blue-800 underline",
};

export const Link: React.FC<LinkProps> = ({
 to,
 variant = "primary",
 external = false,
 className = "",
 children,
 ...props
}) => {
 const baseClasses = `transition-colors ${variantClasses[variant]} ${className}`;

 if (external) {
  return (
   <a
    href={to}
    target="_blank"
    rel="noopener noreferrer"
    className={baseClasses}
    {...(props as React.AnchorHTMLAttributes<HTMLAnchorElement>)}
   >
    {children}
   </a>
  );
 }

 return (
  <RouterLink to={to} className={baseClasses} {...props}>
   {children}
  </RouterLink>
 );
};

export default Link;

